import React from "react";
import { Globe, LayoutDashboard, BrainCircuit, Smartphone, ArrowUpRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { waSolucao } from "../lib/site";

const SOLUTIONS = [
  {
    id: "sites",
    icon: Globe,
    title: "SITES",
    description:
      "Sites modernos, rápidos e responsivos que transformam visitantes em clientes.",
    wa: waSolucao("sites"),
  },
  {
    id: "sistemas",
    icon: LayoutDashboard,
    title: "SISTEMAS",
    description:
      "Sistemas personalizados para otimizar processos, organizar informações e facilitar a gestão.",
    wa: waSolucao("sistemas"),
  },
  {
    id: "ia-automacao",
    icon: BrainCircuit,
    title: "IA & AUTOMAÇÃO",
    description:
      "Automatize tarefas, atendimento e processos com soluções inteligentes.",
    wa: waSolucao("soluções de IA e automação"),
  },
  {
    id: "apps",
    icon: Smartphone,
    title: "APPS",
    description:
      "Aplicativos intuitivos desenvolvidos para necessidades específicas do seu negócio.",
    wa: waSolucao("aplicativos"),
  },
];

const Solutions = () => (
  <section id="solucoes" data-testid="solutions-section" className="relative py-24 lg:py-32">
    <div className="pointer-events-none absolute right-0 top-1/3 h-96 w-96 rounded-full bg-[#8A2BE2]/10 blur-[140px]" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        eyebrow="NOSSAS SOLUÇÕES"
        title={
          <>
            SOLUÇÕES DIGITAIS PARA <span className="text-gradient">O SEU NEGÓCIO</span>
          </>
        }
        description="Da presença digital à automação de processos, desenvolvemos soluções pensadas para as necessidades de cada empresa."
      />

      <div className="mt-16 grid gap-6 md:grid-cols-2">
        {SOLUTIONS.map((s, i) => (
          <Reveal key={s.id} delay={0.08 * i}>
            <article
              data-testid={`solution-card-${s.id}`}
              className="group relative h-full overflow-hidden rounded-3xl border border-white/10 bg-white/[0.02] p-8 transition-[transform,border-color,background-color] duration-500 hover:-translate-y-1.5 hover:border-[#00E5FF]/40 hover:bg-white/[0.04] lg:p-10"
            >
              <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#00E5FF]/10 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100" />
              <div className="relative">
                <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-[#00E5FF]/20 to-[#8A2BE2]/20 ring-1 ring-white/15 transition-transform duration-500 group-hover:scale-110">
                  <s.icon className="h-6 w-6 text-[#00E5FF]" />
                </div>
                <h3 className="mt-7 font-display text-2xl font-bold tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 max-w-md text-sm font-light leading-relaxed text-white/65 md:text-base">
                  {s.description}
                </p>
                <a
                  href={s.wa}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`solution-cta-${s.id}`}
                  className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#00E5FF]/40 bg-[#00E5FF]/10 px-5 py-2.5 text-[11px] font-bold tracking-[0.16em] text-[#7EEEFF] transition-[background-color,border-color,transform] duration-300 hover:scale-[1.03] hover:border-[#00E5FF]/70 hover:bg-[#00E5FF]/20"
                >
                  QUERO UM PROJETO ASSIM
                  <ArrowUpRight className="h-4 w-4" />
                </a>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Solutions;
